export default "__VITE_ASSET__BQSTwV2e__"